module.exports = __webpack_public_path__ + "assets/img/recommend_icon01.5472bed4.png";